import { Peril } from '../../../../../Typescript/classes';

export const GET_TOTAL_RATE_PERIL_NAMES = [
  'Building',
  'Sewer Back-up',
  'Flood',
  'Earthquake',
] as const;

export const TOTAL_RATE_MODIFICATION_PERIL_NAMES = [
  'Building',
  'Contents',
  'Loss of Rent',
  // as per Charbel's email of 2025-06-23, only the above should be changed
  // 'Sewer Back-up',
  // 'Flood',
  // 'Earthquake',
] as const;

interface DisplayPerilOptions {
  displayUnit?: boolean;
}
interface DisplayPerilRateOptions extends DisplayPerilOptions {}
export const displayPerilRate = (
  rate: Peril['rate'],
  options: DisplayPerilRateOptions = {},
) => {
  if (typeof rate !== 'number') {
    return rate;
  }
  const formatOptions: Intl.NumberFormatOptions = {
    maximumFractionDigits: 4,
    style: options.displayUnit ? 'percent' : undefined,
  };
  const formatted = new Intl.NumberFormat(undefined, formatOptions).format(
    rate,
  );
  return formatted;
};

export const displayPerilLimits = (limit: Peril['limit']) => {
  if (limit === undefined || limit === null) {
    return '';
  }
  if (typeof limit !== 'number') {
    return limit;
  }
  return `$${limit.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  })}`;
};

interface DisplayPerilPremiumOptions extends DisplayPerilOptions {}
/**
 * Display the premium, including the dollar sign, appropriate number of decimal places, &c.
 */
export const displayPerilPremium = (
  premium: Peril['premium'],
  options: DisplayPerilPremiumOptions = {},
) => {
  if (premium === undefined || premium === null) {
    return '';
  }
  if (typeof premium !== 'number') {
    return premium;
  }
  return `${options.displayUnit ? '$' : ''}${premium.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  })}`;
};

export const getTotalRate = (perils: Array<Peril>, tiv: number) => {
  const totalRate = perils
    .filter((peril) => {
      // @ts-expect-error
      return GET_TOTAL_RATE_PERIL_NAMES.includes(peril.name);
    })
    .reduce((sum, peril) => {
      const tivRate = getPerilTivRate(peril, tiv);
      return sum + tivRate;
    }, 0);
  return totalRate;
};

/**
 * Returns the TIV rate (only applicable for sewer backup)
 * @returns the rate as a decimal
 */
export const getPerilTivRate = (peril: Peril, tiv: number) => {
  if (tiv && peril.name === 'Sewer Back-up') {
    return peril.premium / tiv;
  }
  return peril.rate;
};
